var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('app-general',{attrs:{"publication":_vm.publication}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }